/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Album } from '../models/Album';
import type { Photo } from '../models/Photo';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class AlbumsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List all the albums this user may access.
     * @returns Album Default Response
     * @throws ApiError
     */
    public getAlbums(): CancelablePromise<Array<Album>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/albums',
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Fetch information on this album.
     * @param slug
     * @returns Album Default Response
     * @throws ApiError
     */
    public getAlbum(
        slug: string,
    ): CancelablePromise<Album> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/albums/{slug}',
            path: {
                'slug': slug,
            },
            errors: {
                403: `Default Response`,
            },
        });
    }
    /**
     * Fetch all the photos in this album.
     * @param slug
     * @returns Photo Default Response
     * @throws ApiError
     */
    public getPhotos(
        slug: string,
    ): CancelablePromise<Array<Photo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/albums/{slug}/photos',
            path: {
                'slug': slug,
            },
            errors: {
                401: `Default Response`,
                403: `Default Response`,
                404: `Default Response`,
            },
        });
    }
    /**
     * Fetch a photo by index. Used to get a random image from the album.
     * @param slug The album slug.
     * @param index The index of the photo, which should be between 0 and length(album) - 1.
     * @param size The size constraint of the photo.
     * @returns any Default Response
     * @throws ApiError
     */
    public getApiAlbumsPhotoJpg(
        slug: string,
        index: number,
        size: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/albums/{slug}/{index}/{size}/photo.jpg',
            path: {
                'slug': slug,
                'index': index,
                'size': size,
            },
        });
    }
    /**
     * Fetch a photo.
     * @param pslug The photo slug.
     * @param size the size constraint of the photo
     * @returns any Default Response
     * @throws ApiError
     */
    public getApiAlbumsPhotoJpg1(
        pslug: string,
        size: number,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/albums/{pslug}/{size}/photo.jpg',
            path: {
                'pslug': pslug,
                'size': size,
            },
        });
    }
    /**
     * Stream a video.
     * @param vslug The video slug.
     * @returns any Default Response
     * @throws ApiError
     */
    public getApiAlbumsVideoMp4(
        vslug: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/albums/{vslug}/video.mp4',
            path: {
                'vslug': vslug,
            },
        });
    }
}
